import type { CSSProperties, ReactNode } from 'react'

/**
 * Eine Zeile — der häufigste Baustein der App.
 *
 * ⚠️ Die Farbe der Person steht als `--stripe` AM ELEMENT. Sie dort zu setzen
 * ist tragend: eine Custom Property, die eine andere referenziert, löst dort
 * auf, wo sie DEFINIERT wird. Ein abgeleitetes Token auf `:root` würde einmal
 * berechnet und vererbt — im dunklen Theme waren dadurch schon einmal alle
 * Streifen gleich grau.
 */
export function ListItem({
  titel,
  unterzeile,
  farbe,
  fuehrend,
  folgend,
  erledigt = false,
  as = 'li',
  className,
}: {
  titel: ReactNode
  // ⚠️ Ausdrücklich `| undefined`: das Projekt fährt exactOptionalPropertyTypes,
  // und diese Angaben kommen aus Berechnungen, die auch nichts liefern dürfen
  // (eine Zeile ohne Person hat keine Farbe). „Nicht gesetzt" und „explizit
  // nichts" bedeuten hier dasselbe.
  unterzeile?: ReactNode | undefined
  farbe?: string | undefined
  fuehrend?: ReactNode | undefined
  folgend?: ReactNode | undefined
  erledigt?: boolean | undefined
  as?: 'li' | 'div' | undefined
  className?: string | undefined
}) {
  const Aussen = as
  return (
    <Aussen
      className={`li${erledigt ? ' li--erledigt' : ''}${className ? ` ${className}` : ''}`}
      // ⚠️ Das Attribut ist die Bedingung für die Aufhellung im dunklen Theme.
      // `color-mix` mit einem nicht gesetzten `--stripe` macht die GANZE
      // Deklaration ungültig - die Zeile bekäme dann `currentColor`, also
      // fast Weiß (gemessen: rgb(228,225,235), die Schriftfarbe). Mit dem
      // Attribut gilt die Regel nur dort, wo es `--stripe` wirklich gibt.
      {...(farbe ? { 'data-person': '' } : {})}
      style={farbe ? ({ '--stripe': farbe } as CSSProperties) : undefined}
    >
      {fuehrend ? <span className="li__fuehrend">{fuehrend}</span> : null}
      <span className="li__text">
        <span className="li__titel">{titel}</span>
        {unterzeile ? <span className="li__unterzeile">{unterzeile}</span> : null}
      </span>
      {folgend ? <span className="li__folgend">{folgend}</span> : null}
    </Aussen>
  )
}
